import { BotMessage, Source, UserMessage } from 'src/types';

type Message = UserMessage | BotMessage;

interface BaseAction {
	type: string;
	[key: string]: unknown;
}

interface AddMessageAction extends BaseAction {
	type: 'message/add';
	payload: Message;
}

interface RemoveAllMessagesAction extends BaseAction {
	type: 'message/remove-all';
}

interface EditMessageAction extends BaseAction {
	type: 'message/edit';
	payload: {
		originalMessage: UserMessage;
		newMessage: UserMessage;
	};
}

interface AddMessageChunk extends BaseAction {
	type: 'message/add-chunk';
	payload: {
		text: string;
		error?: boolean;
	};
}

interface AddMessageOutdated extends BaseAction {
	type: 'message/add-outdated';
	payload: boolean;
}

interface MessageStreamPayLoad {
	questionId: string;
	sources: Source[];
	internetSources: Source[];
	text: string;
	error?: boolean;
}

export interface CompleteMessageStream extends BaseAction {
	type: 'message/add-complete-chunk';
	payload: MessageStreamPayLoad;
}

export type MessageActions =
	| AddMessageAction
	| RemoveAllMessagesAction
	| EditMessageAction
	| AddMessageChunk
	| CompleteMessageStream
	| AddMessageOutdated;

function addMessage(message: Message): AddMessageAction {
	return {
		type: 'message/add',
		payload: message
	};
}

function removeAllMessages(): RemoveAllMessagesAction {
	return {
		type: 'message/remove-all'
	};
}

function editMessage({ newMessage, originalMessage }: { originalMessage: UserMessage; newMessage: UserMessage }): EditMessageAction {
	return {
		type: 'message/edit',
		payload: {
			newMessage,
			originalMessage
		}
	};
}

function addMessageChunk(chunk: string, error?: boolean): AddMessageChunk {
	return {
		type: 'message/add-chunk',
		payload: {
			text: chunk,
			error
		}
	};
}

function addMessageOutdated(outdated: boolean): AddMessageOutdated {
	return {
		type: 'message/add-outdated',
		payload: outdated
	};
}

function completeMessageStream(
	questionId: string,
	sources: Source[],
	internetSources: Source[],
	text: string,
	error?: boolean
): CompleteMessageStream {
	return {
		type: 'message/add-complete-chunk',
		payload: { questionId, sources, internetSources, text, error }
	};
}

const messagesActions = {
	addMessage,
	removeAllMessages,
	editMessage,
	addMessageChunk,
	completeMessageStream,
	addMessageOutdated
};

export default messagesActions;
